(function () {

  // 1. HIDE PRESTIGE'S NATIVE DOT BADGE
  var style = document.createElement('style');
  style.textContent = [
    '.header__cart-count { display: none !important; }',
    '.header__cart-dot   { display: none !important; }',
    'cart-count           { display: none !important; }'
  ].join('\n');
  document.head.appendChild(style);

  // 2. INJECT BADGE HTML INTO PRESTIGE'S CART LINK
  function injectBadge() {
    if (document.getElementById('header-cart-badge')) return;

    var cartLink = document.querySelector(
      'a[href="/cart"][aria-controls="cart-drawer"], ' +
      'a[href="/cart"].header__icon-wrapper, ' +
      '.header__cart-link a, ' +
      'a[data-no-instant][href*="cart"]'
    );

    if (!cartLink) return;

    // Force position relative on the <a> and its <li> parent
    cartLink.style.position = 'relative';
    if (cartLink.parentElement) {
      cartLink.parentElement.style.position = 'relative';
    }

    var badge = document.createElement('span');
    badge.id        = 'header-cart-badge';
    badge.className = 'header__cart-badge header__cart-badge--hidden';
    badge.setAttribute('aria-hidden', 'true');

    // SAFARI FLEX FIX — position absolute + removed from flex flow
    badge.style.cssText = [
      'position: absolute',
      'top: -6px',
      'right: -6px',
      'min-width: 16px',
      'height: 16px',
      'line-height: 16px',
      'background-color: #ffffffff',
      'color: #000000ff',
      'font-size: 10px',
      'font-weight: 700',
      'padding: 0 4px',
      'border-radius: 9999px',
      'text-align: center',
      'display: flex',
      'align-items: center',
      'justify-content: center',
      'pointer-events: none',
      'z-index: 9999',
      'flex-shrink: 0',
      'align-self: auto',
      'margin: 0',
      'inset: auto',
      'top: -6px',
      'right: -6px'
    ].join('; ');

    var count = document.createElement('span');
    count.id = 'header-cart-badge-count';
    count.style.cssText = 'display:block; line-height:1; pointer-events:none;';
    count.textContent = '0';

    badge.appendChild(count);

    // SAFARI FIX — append to <li> instead of <a> to escape the flex container
    var li = cartLink.parentElement;
    li.style.position = 'relative';
    li.appendChild(badge);

    fetchAndUpdate();
  }

  // 3. UPDATE THE BADGE NUMBER
  function updateBadge(count) {
    var badge      = document.getElementById('header-cart-badge');
    var badgeCount = document.getElementById('header-cart-badge-count');
    if (!badge || !badgeCount) return;

    var n = parseInt(count, 10) || 0;
    badgeCount.textContent = n;

    if (n > 0) {
      badge.style.opacity = '1';
      badge.style.transform = 'scale(1)';
      badge.classList.remove('header__cart-badge--hidden');
    } else {
      badge.style.opacity = '0';
      badge.style.transform = 'scale(0)';
      badge.classList.add('header__cart-badge--hidden');
    }
  }

  // 4. FETCH REAL CART COUNT FROM SHOPIFY
  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); })
      .catch(function () {});
  }

  // 5. WAIT FOR DOM THEN INJECT
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadge);
  } else {
    injectBadge();
    if (!document.getElementById('header-cart-badge')) {
      setTimeout(injectBadge, 500);
    }
  }

  // 6. WATCH FOR LIVE CART CHANGES
  var observer = new MutationObserver(function (mutations) {
    var shouldUpdate = false;
    mutations.forEach(function (m) {
      if (m.target && m.target.tagName && m.target.tagName.toLowerCase() === 'cart-count') {
        updateBadge(m.target.textContent.trim()); return;
      }
      if (m.target && m.target.closest && m.target.closest('cart-drawer, #cart-drawer, [id*="cart"]')) {
        shouldUpdate = true;
      }
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName && node.tagName.toLowerCase() === 'cart-count') {
          updateBadge(node.textContent.trim());
        }
        var els = node.querySelectorAll ? node.querySelectorAll('cart-count') : [];
        els.forEach(function (el) { updateBadge(el.textContent.trim()); });
      });
    });
    if (shouldUpdate) {
      clearTimeout(window._cartBadgeTimer);
      window._cartBadgeTimer = setTimeout(fetchAndUpdate, 400);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) updateBadge(e.detail.cart.item_count);
    else fetchAndUpdate();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], [data-add-to-cart], .product-form__submit')) {
      setTimeout(fetchAndUpdate, 800);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-change-quantity], .cart-drawer__quantity button, [aria-label*="quantity"], [aria-label*="Quantity"], .quantity__button')) {
      setTimeout(fetchAndUpdate, 600);
    }
  });

})();